"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

var _NavigateNext = _interopRequireDefault(require("@material-ui/icons/NavigateNext"));

var _Breadcrumbs = _interopRequireDefault(require("@material-ui/core/Breadcrumbs"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getColor = color => {
  color = (0, _color.default)(color);

  if (color.isDark()) {
    return color.hex();
  } else {
    return 'black';
  }
};

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    //        fontSize: "18px",
    //        lineHeight: "24px",
    listStyle: "none",
    color: getColor(theme.palette.primary.main),
    '& li[aria-hidden]': {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
    },
    "& li": {}
  }
}));

const Path = ({
  className,
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement(_Breadcrumbs.default, {
    className: className || classes.root,
    separator: _react.default.createElement(_NavigateNext.default, null)
  }, children);
};

var _default = Path;
exports.default = _default;
module.exports = exports.default;